<template>
  <div>
    <v-row>
      <v-col cols="9"></v-col>
      <v-col>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
          ></v-text-field>
        </v-card-title>
      </v-col>
    </v-row>
    <v-data-table
        :headers="tableHeaders"
        :items="postWatches"
        class="elevation-1"
        :search="search"
        @click:row="rowOnClick"
    >
      <template v-slot:item.watch.enabled="{ item }">
        <v-simple-checkbox disabled v-model="item.watch.enabled" @input="enabledCheckboxOnClick"></v-simple-checkbox>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn text>Delete
        </v-btn>
        <v-btn text @click="enabledCheckboxOnClick(item)">
          {{item.watch.enabled ? 'Disable' : 'Enable'}}
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "PostWatchList",
  data: () => ({
    search: '',
    tableHeaders: [
      {text: 'Post ID', value: 'watch.post_id'},
      {text: 'Subreddit', value: 'post.subreddit'},
      {text: 'Created', value: 'watch.created_at'},
      {text: 'Last Detection', value: 'watch.last_detection'},
      {text: 'Enabled', value: 'watch.enabled'},
      {text: 'Actions', value: 'actions'},
    ]
  }),
  props: {
    postWatches: Array[Object]
  },
  methods: {
    rowOnClick(row) {
      window.open(`https://redd.it/${row.post.post_id}`)
    },
    enabledCheckboxOnClick(item) {
      console.log('Box clicked')
      this.$emit('update-watch', item)
    }
  },
  computed: {
    enableIcon: function (item) {
      return item.watch.enabled ? 'mid-close' : 'mdi-check-bold'
    }
  }
}
</script>

<style scoped>

</style>